import { getProtectedInstance } from "../utils/axiosInstance";
// ?order=${order}&page=${page}&limit=10&active=true
//All COMPANY FETCH
// export const allCompanyService = async (page=1,order="ASC") => {
//   const response = await getProtectedInstance().get(`/company`);
//   const aldata = await response.data.data;
//   console.log("copany aldata", aldata)
export const allCompanyService = async () => {
  const response = await getProtectedInstance().get("/company");
  // console.log(response)
  const aldata = await response.data.data.data;
  return aldata;
};

//POST COMPANY
export const postCompanyDataService = async (body: any) => {
  const response = await getProtectedInstance().post("/company", body);
  const aldata = await response.data;
  // console.log("compannny services all", aldata)
  return aldata;
};

//INDIVIDUAL COMPANY
export const getIndividualCompany = async (id: string) => {
  const response = await getProtectedInstance().get(`/company/${id}`);
  const result = await response.data.data;
  console.log("ind company", result);
  return result;
};

//UPDATE COMPANY
export const patchCompanyDataService = async (id: string, body: any) => {
  const response = await getProtectedInstance().patch(`/company/${id}`, body);
  const aldata = await response.data;
  return aldata;
};

//DELETE COMPANY

export const deleteCompanyService = async (id: string) => {
  const response = await getProtectedInstance().delete(`/company/${id}`);
  return response.data;
};
